import ChoiceHelper from "../../helpers/ChoiceHelper";
import { Card, FormLayout, Layout, Select, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import { CsNonValidation as NV, CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import HeadingHelper from "../../helpers/HeadingHelper";
import Countries from "../../Countries";
import Switch from "react-switch/index";
import Currencies from "../../Currencies";
import React from "react";

const CompanyDetails = (props) => {
  const {
    websiteName, companyName, domainName,
    chiefGender, chiefFirstName, chiefLastName, pubDirectorGender, pubDirectorFirstName, pubDirectorLastName,
    registrationState, registrationCountry, companyRegistrationID, regulatedActivity,
    companyType, companyTypeOther, capital, currency, registrationDate,
    handleChange, handleSelectChange,
    validatorClass,
  } = props;

  const companyTypeSelected = ChoiceHelper.selectedFirst(companyType),
    isAutoEntrepreneur = companyTypeSelected === 'auto_entrepreneur';

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("company.annotate.title.website")}
      description={CsI18n.t("company.annotate.desc.website")}>
      <Card sectioned>
        <CsValidationForm name={validatorClass} realtime={true}>
          <FormLayout>
            <FormLayout.Group>
              <NV>
                <Select
                  label={HeadingHelper.h3tt('Company type', 'company.explain.company_type')}
                  options={ChoiceHelper.choices(companyType)}
                  value={companyTypeSelected}
                  onChange={handleSelectChange('companyType')} />
              </NV>
              {companyTypeSelected === 'other' &&
              <V>
                <TextField label={HeadingHelper.h3('Other')} onChange={handleChange('companyTypeOther')}
                           value={companyTypeOther} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>}
            </FormLayout.Group>
            <FormLayout.Group>
              <V>
                <TextField
                  label={HeadingHelper.h3tt('Website Name', 'company.explain.website_name')}
                  onChange={handleChange('websiteName')}
                  value={websiteName} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                <V.Item rule="websiteWtProtocol" title={CsI18n.t("Not a valid website.")} />
              </V>
            </FormLayout.Group>
            {!isAutoEntrepreneur &&
            <FormLayout.Group>
              <V>
                <TextField
                  label={HeadingHelper.h3('Company Name')}
                  onChange={handleChange('companyName')} value={companyName} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
            </FormLayout.Group>}
            <FormLayout.Group>
              <V>
                <TextField
                  label={HeadingHelper.h3tt('Domain Name', 'company.explain.domain_name')}
                  onChange={handleChange('domainName')} value={domainName} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                <V.Item rule="websiteWtProtocol" title={CsI18n.t("Not a valid website.")} />
              </V>
            </FormLayout.Group>


            <div className="name-group">
              <FormLayout.Group
                title={HeadingHelper.h3tt('Publication Director', 'company.explain.pub_director')}
                condensed>
                <NV>
                  <Select
                    label={CsI18n.t("Gender")}
                    options={[
                      { label: CsI18n.t('Mr.'), value: 'mr' },
                      { label: CsI18n.t('Ms'), value: 'ms' },
                    ]}
                    value={pubDirectorGender}
                    onChange={handleChange('pubDirectorGender')} />
                </NV>
                <V>
                  <TextField label={CsI18n.t("First Name")} onChange={handleChange('pubDirectorFirstName')}
                             value={pubDirectorFirstName} />
                  <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                </V>
                <V>
                  <TextField label={CsI18n.t("Last Name")} onChange={handleChange('pubDirectorLastName')}
                             value={pubDirectorLastName} />
                  <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                </V>
              </FormLayout.Group>
            </div>
            <div className="name-group">
              <FormLayout.Group
                condensed
                title={HeadingHelper.h3tt('Chief Operating Officer', 'company.explain.chief')}>
                <NV>
                  <Select
                    label={CsI18n.t("Gender")}
                    options={[
                      { label: CsI18n.t('Mr.'), value: 'mr' },
                      { label: CsI18n.t('Ms'), value: 'ms' },
                    ]}
                    value={chiefGender}
                    onChange={handleChange('chiefGender')} />
                </NV>
                <V>
                  <TextField label={CsI18n.t("First Name")} onChange={handleChange('chiefFirstName')}
                             value={chiefFirstName} />
                  <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                </V>
                <V>
                  <TextField label={CsI18n.t("Last Name")} onChange={handleChange('chiefLastName')}
                             value={chiefLastName} />
                  <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                </V>
              </FormLayout.Group>
            </div>


            <FormLayout.Group>
              <NV>
                <Select
                  label={HeadingHelper.h3tt('Registration Country', 'company.explain.reg_country')}
                  options={ChoiceHelper.choices(Countries, false)}
                  value={registrationCountry}
                  onChange={handleChange('registrationCountry')}
                />
              </NV>
              <V>
                <TextField type="text" label={HeadingHelper.h3tt('Registration state', 'company.explain.reg_state')}
                           onChange={handleChange('registrationState')} value={registrationState} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
              <V>
                <TextField
                  label={HeadingHelper.h3tt('Company registration ID', 'company.explain.reg_number')}
                  onChange={handleChange('companyRegistrationID')} value={companyRegistrationID} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
            </FormLayout.Group>
            <div>
              {HeadingHelper.h3tt('Regulated activity', 'company.explain.regulated_industry')}
              <Switch
                className="react-switch"
                onChange={handleChange('regulatedActivity')}
                checked={regulatedActivity}
                uncheckedIcon={false}
                checkedIcon={false}
                aria-label={CsI18n.t("Regulated activity")}
              />
            </div>
            {!isAutoEntrepreneur &&
            <FormLayout.Group condensed>
              <V>
                <TextField type="number" label={CsI18n.t("Capital")} onChange={handleChange('capital')}
                           value={capital} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                <V.Item rule="float" title={CsI18n.t("Not a float number.")} />
              </V>
              <Select
                label={CsI18n.t("Currency")} value={currency}
                options={ChoiceHelper.choices(Currencies, false)} onChange={handleChange('currency')}
              />
              <V>
                <TextField type="date" label={CsI18n.t("Date of registration")}
                           onChange={handleChange('registrationDate')} value={registrationDate} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
            </FormLayout.Group>}

            {/*Remove optInGranted*/}
          </FormLayout>
        </CsValidationForm>
      </Card>
    </Layout.AnnotatedSection>
  )
};

export default CompanyDetails